import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Box } from 'grommet'
import { useDarkMode } from '../../contextHook/darkMode'

const Container = styled(Box)`
  z-index: 10;
  position: absolute;
  width: 100%;
  min-height: 100%;
  height: ${props => (!props.downloading ? '100%' : 'auto')};
  /* height: auto; */
  /* top: 0;
left: 0; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* color: ${props => props.theme.global.colors.whiteText}; */
  max-width: ${props => (props.fullScreenActive ? '100%' : '65rem')};
  /* border: 3px solid ${props => props.theme.global.colors.text}; */
  border: 4px solid ${props => props.theme.global.colors.border};
  box-shadow: 2px 2px 3px 1px rgba(180, 178, 178, 0.5);
  @media (max-width: 500px) {
    padding: 0.8rem;
  }
`

const BackgroundAllResults = ({
  justify = 'start',
  name,
  downloading,
  children,
  fullScreenActive,
}) => {
  const toolColors = useSelector(state => state.settings.wheelColors.colors)
  const { value: darkMode } = useDarkMode()
  return (
    <Container
      id={name}
      background="baseBackground" //"rgba(17, 17, 17, 0.8)"
      round="2rem"
      align="center"
      pad="1.5rem"
      justify={justify}
      downloading={downloading}
      fullScreenActive={fullScreenActive}
      toolColors={
        !darkMode || toolColors.length < 3 ? toolColors[0] : toolColors[2]
      }
    >
      {children}
    </Container>
  )
}

export default BackgroundAllResults
